import { useReleaseFlag } from 'hooks/useReleaseFlags';

export const useWeatherStationPrecipitationEnabled = (): boolean => {
  return useReleaseFlag('weather_station_precipitation');
};
